var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlueLeftIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.34626 4.83833L9.67958 4.82229C12.441 4.81697 14.6839 7.05124 14.6892 9.81266C14.6945 12.5741 12.4602 14.817 9.69883 14.8223L1.36551 14.8383M1.34626 4.83833L4.67317 1.49859M1.34626 4.83833L4.686 8.16524",
    stroke: "#60BFDA",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueLeftIcon);
export default __webpack_public_path__ + "static/media/blue-left-icon.13170d8045528297facb3234301a7bfc.svg";
export { ForwardRef as ReactComponent };